import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Index from '@/components/index/index'
import Login from '@/components/login/login'
import Forget from '@/components/login/forget'
import Register from '@/components/login/register'
import Layout from '@/components/index/layout'
import Movie from '@/components/index/movie'
import User from '@/components/index/user'


import Actor from '@/components/index/actor'

import Category from '@/components/index/category'

import Account from '@/components/index/account'
import Categorydetail from '@/components/index/categorydetail'
import Searchuser from '@/components/index/searchuser'
import Searchmovie from '@/components/index/searchmovie'
import Test from '@/components/index/test'
import Movies from '@/components/index/movies'
import Forum from '@/components/index/forum'
import Createforum from '@/components/index/createforum'
import Forumdetail from '@/components/index/forumdetail'
import Editforum from '@/components/index/editforum'
import Topicdetail from '@/components/index/topicdetail'
import Createtopic from '@/components/index/createtopic'
import Aboutus from '@/components/index/aboutus'
import Feedback from '@/components/index/feedback'
import VueRouter from 'vue-router'
// import Clip from '@/components/index/clip'
// Vue.use(Router)
Vue.use(VueRouter)
// const $urlfrom = '';
const router = new VueRouter({
// export default new VueRouter({
  //这里设置了history 上线时需要在服务器配置文件中作相应的配置
  // mode: 'history',
  routes: [
    { path: '/', redirect: '/index' },
    {
      path: '/',
      name: 'Layout',
      component: Layout,
      children:[
        {path:'/index',name:'index',component:Index},
        {path:'/movie/:id',name:'movie',component:Movie},
        {path:'/user/:uid',name:'user',component:User},


        {path:'/actor/:aid',name:'actor',component:Actor},

        {path:'/category',name:'category',component:Category},
        {path:'/categorydetail/:keyword',name:'categorydetail',component:Categorydetail},
        {path:'/searchuser/:keyword',name:'searchuser',component:Searchuser},
        {path:'/searchmovie/:keyword',name:'searchmovie',component:Searchmovie},
        {path:'/account',component:Account},
        {path:'/test',name:'test',component:Test},
        {path:'/movies',name:'movies',component:Movies},
        {path:'/forum',name:'forum',component:Forum},
        {path:'/createforum',component:Createforum},
        {path:'/forumdetail/:fid',name:"forumdetail",component:Forumdetail},
        {path:'/editforum/:fid',name:"editforum",component:Editforum},
        {path:'/topicdetail/:tid',name:'topicdetail',component:Topicdetail},
        {path:'/createtopic',aboutusname:'createtopic',component:Createtopic},
        {path:'/aboutus',name:'aboutus',component:Aboutus},
        {path:'/feedback',name:'feedback',component:Feedback},
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/forget',
      name: 'Forget',
      component: Forget
    },
    
  ],

  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0}
  }
})
// router.beforeEach((to, from, next) => {
//   console.log('to')
//   console.log(to)
//   console.log('from')
//   this.$urlfrom = from
//   console.log(this.$urlfrom)
//   next();
// })
// export default urlfrom;
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js